import React from 'react';
import SubscriptionManager from './SubscriptionManager';
import './SubscriptionModal.css';

function SubscriptionModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="subscription-modal-overlay" onClick={onClose}>
      <div className="subscription-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="subscription-modal-close" onClick={onClose}>
          ✕
        </button>
        <SubscriptionManager />
      </div>
    </div>
  );
}

export default SubscriptionModal;
